module.exports = __webpack_public_path__ + "img/welcome-page-img5.fd02d487.svg";